import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import NavigationFooter from '../footer/navigation';
import FooterPayments from '../footer/payments';
import Disclaimer from '../footer/disclaimer';
import FooterSocial from '../footer/social';
import Salutation from '../../elements/txt-salutation';
import Version from '../footer/version';

const Footer = inject("stores") (
    observer (
        class Footer extends Component {

            constructor(props) {
                super(props);
                this.props = props;
                this.state = {
                    footerHeight: 0
                }

                this.storeUi = this.props.stores.storeUi;
                this.storeGeneral = this.props.stores.storeGeneral;
            }

            //SbC footer height is no longer measured: height_footer is unused and
            //react-sizeme cost a lot of main-thread time on page load

            render() {
                return (
                    <footer className="wrapper-footer">
                        <FooterSocial />
                        <FooterPayments />
                        <NavigationFooter />
                        <Salutation />
                        {this.storeGeneral.shop === 'SHOP_SB' &&
                            <Disclaimer />
                        }
                        <Version />
                    </footer>
                )
            }
        }
    )
)

export default Footer;
